import { Flex } from "antd";
import { Outlet } from "react-router-dom";
import { useTheme } from "../providers/ThemeProvider";
import { Header } from "./header";

export function Layout() {
  const { theme } = useTheme();

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "0% 100%",
        backgroundImage:
          theme == "LIGHT"
            ? 'url("/assets/timeline_bg_white.jpg")'
            : 'url("/assets/timeline_bg.jpg")',
      }}
    >
      <Flex
        vertical
        style={{
          width: "100%",
          height: "100%",
          backgroundColor:
            theme == "LIGHT" ? "rgba(255,255,255, 0.5)" : "rgba(0,0,0,0.7)",
        }}
      >
        <Header />
        <Outlet />
      </Flex>
    </div>
  );
}
